import React, { type ReactNode } from 'react'

import { InputUI } from '@fourthwall/components'

import type { CardField } from '../../AddPaymentMethod.types'
import * as S from './StripeField.styled'

export type StripeFieldProps = {
  field: CardField
  append?: ReactNode
}

export const StripeField = ({ field, append }: StripeFieldProps) => (
  <div>
    <InputUI.Box $invalid={!!field.error} $focused={field.isFocused} $fullWidth>
      <S.Input ref={field.ref} />
      {append}
    </InputUI.Box>
    {field.error && <InputUI.Error>{field.error}</InputUI.Error>}
  </div>
)
